export default __webpack_public_path__ + "static/background-hero-home-inter-asset-md-48b13c1d16cf94c105221507ab380040.png";